import { Box } from '@mui/joy';

const HorizontalSpacer = () => {
  return <Box sx={{ display: 'flex', height: '1px', flex: 1 }} />;
};

export default HorizontalSpacer;
